import { LanguageInterface } from "../../interfaces/shared/LanguageInterface";

export interface ProductDetailPageLoadingParams {
    isUserLoading: boolean;
    translationsLoaded: boolean;
    activeLanguage: LanguageInterface | null;
    /** True when the product query is skipped or still in flight. */
    isProductPending: boolean;
}

/** True while user, translations, or product data are not ready to render content. */
export const isProductDetailPageLoading = ({
    isUserLoading,
    translationsLoaded,
    activeLanguage,
    isProductPending,
}: ProductDetailPageLoadingParams): boolean =>
    isUserLoading || !activeLanguage || !translationsLoaded || isProductPending;
